const initProductUsage = () => {
    const sections = document.querySelectorAll(".ProductUsage");

    sections.forEach((section) => {
        const allStepTabs = section.querySelectorAll(".ProductUsage--step");
        const allStepProducts = section.querySelectorAll(".ProductUsage--product");

        let currentTab = allStepProducts[0];

        allStepTabs.forEach((tab) => {
            tab.addEventListener("click", (e) => {
                allStepTabs.forEach((tab) => {
                    tab.classList.remove("Active");
                });
                tab.classList.add("Active");

                const tabId = tab.dataset.stepId;
                onTabChanged(tabId);
            });
        });

        function onTabChanged(tabId) {
            if (tabId === currentTab.dataset.stepId) return;
        
            removeActive(currentTab);
        
            allStepProducts.forEach((product) => {
            if (product.dataset.stepId === tabId) {
                currentTab = product;
                setActive(product);
            }
            });
        }

        function setActive(product) {
            product.classList.add("Active");
            product.classList.remove("Inactive");
        
            const productThumbnails = product.querySelectorAll(".ProductThumbnail");
            productThumbnails.forEach((thumbnail) => {
            thumbnail.classList.add("Shown");
            });
        }
    
        function removeActive(product) {
            product.classList.add("Inactive");
            product.classList.remove("Active");
            setTimeout(() => {
            product.classList.remove("Inactive");
            const productThumbnails =
                product.querySelectorAll(".ProductThumbnail");
            productThumbnails.forEach((thumbnail) => {
                thumbnail.classList.remove("Shown");
            });
            }, 500);
        }
    });

    
}

initProductUsage();